<template>
  <div class="avatar" :class="getSize(size)">
    <img
      :src="img"
      :alt="alt"
      :class="[getClasses(shadow, circular, borderRadius)]"
      @error="handleImageError"
    />
  </div>
</template>

<script>
export default {
  name: 'SoftAvatar',
  props: {
    img: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: null
    },
    shadow: {
      type: String,
      default: null
    },
    borderRadius: {
      type: String,
      default: null
    },
    circular: Boolean
  },
  methods: {
    getSize: (size) => (size ? `avatar-${size}` : null),
    getClasses: (shadow, circular, borderRadius) => {
      let shadowValue, circularValue, borderRadiusValue

      if (shadow) {
        shadowValue = shadow === 'regular' ? 'shadow' : `shadow-${shadow}`
      } else {
        shadowValue = null
      }

      // eslint-disable-next-line prefer-const
      circularValue = circular ? 'rounded-circle' : null

      // eslint-disable-next-line prefer-const
      borderRadiusValue = borderRadius ? `border-radius-${borderRadius}` : null

      return `${shadowValue} ${circularValue} ${borderRadiusValue}`
    },
    handleImageError (event) {
      event.target.src = 'https://via.placeholder.com/374x374'
    }
  }
}
</script>
